<template>
  <v-layout>
    <v-flex v-if="reportsPending">
      <v-flex>
        Getting referrals...
        <v-progress-linear indeterminate></v-progress-linear>
      </v-flex>
    </v-flex>
    <v-flex v-else>
      <v-layout column full-width>
        <v-layout row>
          <v-flex>
            <v-select
              :items="dateChoices"
              label="Time Period"
              v-model="selectedDateRange"
            />
          </v-flex>
          <v-flex>
            <template>
              <v-menu
                ref="startDateMenu"
                v-model="startDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template slot="activator" slot-scope="{ on }">
                  <v-text-field
                    label="Referred on Beginning"
                    format="dddd, MM DD YYYY"
                    @change="value => startDate = value"
                    :value="dateFormatted(startDate)"
                    prepend-icon="event"
                    readonly
                    :disabled="selectedDateRange == 'weeks'"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker :show-current="endDate" v-model="startDate" @input="startDateMenu = false" no-title scrollable
                >
                </v-date-picker>
              </v-menu>
              </template>
            </v-flex>
          <template>
            <v-flex>
              <v-menu
                ref="endDateMenu"
                v-model="endDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template slot="activator" slot-scope="{ on }">
                  <v-text-field
                    label="Referred on Ending"
                    format="dddd, MM DD YYYY"
                    @change="value => endDate = value"
                    :value="dateFormatted(endDate)"
                    prepend-icon="event"
                    readonly
                    :disabled="selectedDateRange == 'weeks'"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker :show-current="startDate" v-model="endDate" @input="endDateMenu = false" no-title scrollable>
                </v-date-picker>
              </v-menu>
            </v-flex>
          </template>
          <v-flex>
            <v-btn @click="reGetRecords" color="primary">
              Fetch
            </v-btn>
          </v-flex>
        </v-layout>

        <v-flex grow>
          <v-card>
            <v-card-text>
              <div class="mb-3">
                <span class="subheading">Referral Count:</span>
                <ul>
                  <li v-for="(count, name) in summary" :key="name">
                    {{ name }}: {{ count }}
                  </li>
                </ul>
              </div>

              <v-data-table
                :items="report"
                :headers="headers"
                item-key="worksite_id"
                class="elevation-1"
                :defaultSort="{
                  sortBy: '',
                  ascending: true,
                  rowsPerPage: 100,
                }"
              >
                <template slot="items" slot-scope="{ item }">
                  <tr>
                    <td>
                      <router-link :to="{ name: 'clientDetail', params: { clientId: item.user_id } }" target="_blank">{{ item.display_name }}</router-link>
                    </td>
                    <td>
                      {{ item.referred_by_name }}
                    </td>
                    <td>
                      {{ item.referred_at | moment('YYYY-MM-DD') }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>

      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
  import {mapState, mapGetters} from 'vuex';
  import reportApi from '@/api/reports'
  import collectionApi from '@/api/collections'

  export default {
    computed: {
      ...mapState('userAuth', ['user']),
      summary() {
        return this.report.map(r => r.referred_by_name).reduce((acc, curr) => {
          acc[curr] = -~acc[curr];
          return acc;
        }, {});
      },
      //computedOffset: function () {
      //  return this.limit * (this.page - 1)
      //},
      //pageLength: function () {
      //  return Math.ceil(this.queryTotal / this.limit)
      //},
      formattedQuery: function() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
          //limit: this.limit,
          //offset: this.computedOffset,
          //page: this.page,
        };
      },
    },
    created() {
      this.setUp();
    },
    watch: {
    },
    data: function() {
      return {
        dateChoices: [
          {text: 'Past Two Weeks', value: 'weeks'},
          {text: 'Custom', value: 'custom'}
        ],
        selectedDateRange: 'weeks',
        limit: 40,
        page: 1,
        startDateMenu: false,
        endDateMenu: false,
        startDate: this.$moment()
          .subtract(2, 'week').format('YYYY-MM-DD'),
        endDate: this.$moment().format('YYYY-MM-DD'),

        reportsPending: true,
        report: {},
        //defaultSort: {
        //  sortBy: 'order',
        //  rowsPerPage: -1, //all
        //},
        headers: [
          { text: 'Client', value: 'display_name', sortable: true },
          { text: 'Referred By', value: 'referred_by_name', sortable: true },
          { text: 'Referral Date', value: 'referred_at', sortable: true },
        ],
      };
    },

    methods: {
      getWorksites() {
        if (this.selectableWorksites.length === 0) {
          this.apiCallPending = true
          collectionApi.getLocations(worksites => {
            this.selectableWorksites = worksites
            this.apiCallPending = false
          })
        }
      },

      setUp: function() {
        this.createdStartDate = this.$route.query.startDate || this.startDate;
        this.createdEndDate = this.$route.query.endDate || this.endDate;
        this.getReports();
      },

      dateFormatted: function(date) {
        return date ? this.$moment(date).format('dddd, MMMM D') : '';
      },

      getReports: function() {
        this.reportsPending = true;

        reportApi.getReferralReport(
          this.formattedQuery,
          r => {
            this.report = r.report
            this.reportsPending = false
          },
          err => {
            console.log(err)
            this.reportsPending = false
          }
        )
      },

      reGetRecords: function() {
        this.getReports()
      },
    },
  };
</script>
